import { useAuthLibContext as i } from "../contexts/AuthLibContext.js";
import { ERROR_CODE as m } from "../../temp-lib/constants/error.js";
import { ssoProviderSchema as a } from "../../temp-lib/deserialize/yup/account.js";
import { CustomError as f } from "../../temp-lib/errors/customError.js";
import p from "../../temp-lib/hooks/json/useReactQueryFetchJson.js";
import * as s from "ramda";
import { useCallback as u, useMemo as h } from "react";
const S = (d) => {
  const {
    config: t
  } = i(), {
    fetchNow: n
  } = {}, r = u(() => {
    const {
      fetchJson: o
    } = t;
    if (s.isNil(o))
      throw new f('config "fetchJson" is not defined', m.GENERAL.MISSING_CONFIG);
    return o.ssoPath;
  }, [t]), c = h(() => r(), [r]);
  return p({
    fetchNow: n,
    path: c,
    deserialize: (o) => s.map((e) => a.cast(e, {
      context: {
        data: e
      }
    }), o)
  });
};
export {
  S as default
};
//# sourceMappingURL=useFetchSsoJson.js.map
